import { z } from 'zod';
import { PaginationResponseSchema } from '@terra/shared-dto-types';
import { MongoObjectIdSchema } from '@terra/shared-utils';

export const DirectoryScanWordlistSizeSchema = z.enum([
  'small',
  'medium',
  'large',
]);

export const DirectoryScanHttpMethodSchema = z.enum([
  'GET',
  'POST',
  'PUT',
  'DELETE',
  'PATCH',
]);

export const DirectoryScanStatusSchema = z.enum([
  'PENDING',
  'RUNNING',
  'ANALYZING',
  'COMPLETED',
  'FAILED',
  'STOPPED',
]);

export const DirectoryScanVerificationStatusSchema = z.enum([
  'PENDING',
  'VERIFIED',
  'SOFT_404',
  'FAILED',
]);

export const DirectoryScanConfigSchema = z.object({
  wordlistSize: DirectoryScanWordlistSizeSchema,
  httpMethod: DirectoryScanHttpMethodSchema.default('GET'),
  startPath: z.string().optional(),
  credentialId: MongoObjectIdSchema.optional(),
});

export const DirectoryScanResultItemSchema = z.object({
  url: z.string().url(),
  statusCode: z.number(),
  contentLength: z.number().nullable().optional(),
  words: z.number().nullable().optional(),
  lines: z.number().nullable().optional(),
  verificationStatus: DirectoryScanVerificationStatusSchema,
  candidateId: MongoObjectIdSchema.nullish(),
});

export const StartDirectoryScanBodySchema = DirectoryScanConfigSchema;

export const StartDirectoryScanResponseSchema = z.object({
  scanId: MongoObjectIdSchema,
  status: DirectoryScanStatusSchema,
});

export const DirectoryScanResponseSchema = z.object({
  id: MongoObjectIdSchema,
  applicationId: MongoObjectIdSchema,
  status: DirectoryScanStatusSchema,
  config: DirectoryScanConfigSchema,
  results: z.array(DirectoryScanResultItemSchema),
  error: z.string().nullable().optional(),
  createdAt: z.string(),
  completedAt: z.string().nullable().optional(),
});

export const DirectoryScanListResponseSchema = z.object({
  scans: z.array(DirectoryScanResponseSchema),
  pagination: PaginationResponseSchema,
});

export type DirectoryScanWordlistSize = z.infer<
  typeof DirectoryScanWordlistSizeSchema
>;
export type DirectoryScanHttpMethod = z.infer<
  typeof DirectoryScanHttpMethodSchema
>;
export type DirectoryScanStatus = z.infer<typeof DirectoryScanStatusSchema>;
